import "./BannerTicker.css";

export default function BannerTicker({text}) {
  return (
    <div className="ticker-wrapper">
      <p className="ticker-text">
        {text || "WELCOME TO GAMA567 24x7 Service Available Contact on WhatsApp"}
      </p>
    </div>
  );
}
